import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  AgCellWrapperComponent,
  ICellWrapperParams,
} from '@shared/ag-components/ag-cell-wrapper/ag-cell-wrapper.component';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }
    `,
  ],
  template: `
    <div class="flex h-full items-center justify-items-start space-x-2 align-middle">
      <div class="mr-1 h-3 w-3 rounded-full" [ngClass]="bgClass"></div>
      <div [ngClass]="textClass" [attr.auto-qa]="autoTestAttribute">{{ status }}</div>
    </div>
  `,
})
export class PortfolioStatusComponent
  extends AgCellWrapperComponent
  implements ICellRendererAngularComp
{
  bgClass!: string;
  params!: ICellWrapperParams;
  status!: string;
  textClass!: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const status: string = params.data.status || '';

    switch (status) {
      case 'Closed':
        this.bgClass = 'bg-aux-green-dark';
        this.textClass = 'text-aux-blue-dark underline text-sm';
        this.status = 'Closed';
        break;
      case 'Open':
        this.bgClass = 'bg-aux-warn';
        this.textClass = 'text-aux-blue-dark underline text-sm';
        this.status = 'Open';
        break;
      default:
        this.bgClass = '';
        this.textClass = 'text-aux-black text-sm';
        this.status = Utils.zeroHyphen;
        break;
    }

    this.autoTestAttribute = this.getAutoTestAttribute(params);
  }
}
